export enum CustomerSortEnum {
  HighestInvoiceCount = "HIGHEST_INVOICE_COUNT",
  LowestInvoiceCount = "LOWEST_INVOICE_COUNT",

  HighestPurchaseAmount = "HIGHEST_PURCHASE_AMOUNT",
  LowestPurchaseAmount = "LOWEST_PURCHASE_AMOUNT",

  HighestAverageInvoiceAmount = "HIGHEST_AVERAGE_INVOICE_AMOUNT",
  LowestAverageInvoiceAmount = "LOWEST_AVERAGE_INVOICE_AMOUNT",

  CustomersWithoutPurchase = "CUSTOMERS_WITHOUT_PURCHASE",
  NewCustomers = "NEW_CUSTOMERS",
  LoyalCustomers = "LOYAL_CUSTOMERS",
}
